import { css } from '@emotion/react'

import { colors } from '../../../../styles/theme'

export default css`
  color: ${colors.heatherField};

  .cr-logo-svg {
    fill: ${colors.white};

    @media (hover: hover) {
      &:hover {
        fill: ${colors.orange};
      }
    }
  }

  .to-top {
    color: ${colors.silver};

    .icon-chevron {
      stroke: ${colors.silver};
    }

    @media (hover: hover) {
      &:hover {
        color: ${colors.white};

        .icon-chevron {
          stroke: ${colors.white};
        }
      }
    }
  }

  .social-link {
    background-color: ${colors.silver};

    .social-icon {
      fill: ${colors.shark};

      .vk {
        &-bg {
          fill: ${colors.white};
        }

        &-logo {
          fill: ${colors.shark};
        }
      }
    }

    @media (hover: hover) {
      &:hover {
        background-color: ${colors.white};
      }
    }
  }

  .legal-item > span {
    color: ${colors.silver};
  }

  .legal-link,
  .legal-dns span {
    color: ${colors.silver};

    @media (hover: hover) {
      &:hover {
        color: ${colors.white};
      }
    }
  }

  .language {
    &-toggle {
      color: ${colors.shark};
      background-color: ${colors.silver};
    }

    &-current {
      .triangle-svg {
        fill: ${colors.shark};
      }

      @media (hover: hover) {
        &:hover {
          color: ${colors.woodsmoke};
          background-color: ${colors.white};

          .triangle-svg {
            fill: ${colors.woodsmoke};
          }
        }
      }
    }

    &-list {
      background-color: ${colors.silver};
      border-bottom: 0.0625rem solid ${colors.shark};
    }

    &-item {
      @media (hover: hover) {
        &:hover {
          color: ${colors.woodsmoke};
          background-color: ${colors.white};
        }
      }
    }
  }

  .byline {
    color: ${colors.silverChalice};
  }
`
